import { api } from './api';
import { entriesAddMany } from '../containers/contentSlice';
import { QueryEntry } from '../types';

function normalizeWhereForUrl(where?: string): string | undefined {
	if (!where) {
		return undefined;
	}
	const trimmed = where.trim();
	if (!trimmed) {
		return undefined;
	}
	return encodeURIComponent(trimmed);
}

export const queriesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		queryCreate: builder.mutation<QueryEntry, QueryEntry>({
			query: (entry) => {
				const c = entry as QueryEntry;
				return {
					url: 'queries',
					method: 'POST',
					body: {
						id: entry.id,
						title: c.title ?? '',
						repositoryId: c.repositoryId,
						parentId: entry.parentId,
						rank: Number(entry.rank),
						where: c.where,
						includeArchived: c.includeArchived !== false,
						xy: c.xy,
					},
				};
			},
			async onQueryStarted(entry, { dispatch }) {
				dispatch(entriesAddMany([entry]));
			},
			invalidatesTags: ['RepositoryEntryCount'],
		}),
		repositoryEntryCount: builder.query<
			number,
			{ repositoryId: string; dataFilter?: string; includeArchived?: boolean }
		>({
			query: ({ repositoryId, dataFilter, includeArchived }) => {
				const params = new URLSearchParams();
				const encoded = normalizeWhereForUrl(dataFilter);
				if (encoded) {
					params.set('dataFilter', encoded);
				}
				params.set('includeArchived', String(includeArchived !== false));
				return {
					url: `queries/repositories/${repositoryId}/entry-count?${params.toString()}`,
					method: 'GET',
				};
			},
			transformResponse: (response: { count: number }) => response.count,
			providesTags: (_result, _error, args) => [
				{
					type: 'RepositoryEntryCount',
					id: `${args.repositoryId}:${String(args.includeArchived !== false)}:${args.dataFilter ?? ''}`,
				},
			],
		}),
	}),
});

export const { useRepositoryEntryCountQuery, useQueryCreateMutation } = queriesApi;
